import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function MicroPhoneIcon({ className, width = 30, height = 30 }: IconProps) {
    return (
        <svg
            className={cn('text-gray-700', className)}
            width={width}
            height={height}
            viewBox='0 0 30 30'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M15 20.3125C11.725 20.3125 9.0625 17.65 9.0625 14.375V7.5C9.0625 4.225 11.725 1.5625 15 1.5625C18.275 1.5625 20.9375 4.225 20.9375 7.5V14.375C20.9375 17.65 18.275 20.3125 15 20.3125ZM15 3.4375C12.7625 3.4375 10.9375 5.2625 10.9375 7.5V14.375C10.9375 16.6125 12.7625 18.4375 15 18.4375C17.2375 18.4375 19.0625 16.6125 19.0625 14.375V7.5C19.0625 5.2625 17.2375 3.4375 15 3.4375Z'
                fill='currentColor'
            />
            <path
                d='M15 24.6875C9.2125 24.6875 4.5 19.975 4.5 14.1875V12.0625C4.5 11.55 4.925 11.125 5.4375 11.125C5.95 11.125 6.375 11.55 6.375 12.0625V14.1875C6.375 18.9375 10.25 22.8125 15 22.8125C19.75 22.8125 23.625 18.9375 23.625 14.1875V12.0625C23.625 11.55 24.05 11.125 24.5625 11.125C25.075 11.125 25.5 11.55 25.5 12.0625V14.1875C25.5 19.975 20.7875 24.6875 15 24.6875Z'
                fill='currentColor'
            />
            <path
                d='M16.7376 8.97499C16.6376 8.97499 16.5251 8.96249 16.4126 8.92499C15.5001 8.58749 14.5001 8.58749 13.5876 8.92499C13.1001 9.09999 12.5626 8.84999 12.3876 8.36249C12.2126 7.87499 12.4626 7.33749 12.9501 7.16249C14.2751 6.68749 15.7376 6.68749 17.0626 7.16249C17.5501 7.33749 17.8001 7.87499 17.6251 8.36249C17.4751 8.73749 17.1126 8.97499 16.7376 8.97499Z'
                fill='currentColor'
            />
            <path
                d='M16.0001 11.625C15.9126 11.625 15.8376 11.6125 15.7501 11.5875C15.2501 11.45 14.7376 11.45 14.2376 11.5875C13.7376 11.725 13.2251 11.425 13.0876 10.925C12.9501 10.4375 13.2501 9.92499 13.7501 9.78749C14.5626 9.56249 15.4376 9.56249 16.2501 9.78749C16.7501 9.92499 17.0501 10.4375 16.9126 10.9375C16.8001 11.35 16.4126 11.625 16.0001 11.625Z'
                fill='currentColor'
            />
            <path
                d='M15 28.4375C14.4875 28.4375 14.0625 28.0125 14.0625 27.5V23.75C14.0625 23.2375 14.4875 22.8125 15 22.8125C15.5125 22.8125 15.9375 23.2375 15.9375 23.75V27.5C15.9375 28.0125 15.5125 28.4375 15 28.4375Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default MicroPhoneIcon;

